module.exports = __webpack_public_path__ + "img/3.9069a66e.jpg";